import { render, staticRenderFns } from "./detached.vue?vue&type=template&id=5aa47227&"
import script from "./detached.vue?vue&type=script&lang=js&"
export * from "./detached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports